import { render } from "./inviteForm.vue?vue&type=template&id=469a245f&scoped=true&ts=true"
import script from "./inviteForm.vue?vue&type=script&lang=ts"
export * from "./inviteForm.vue?vue&type=script&lang=ts"

import "./inviteForm.vue?vue&type=style&index=0&id=469a245f&lang=less&scoped=true"

import exportComponent from "D:\\wamp\\UF\\uf-approve-h5\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-469a245f"]])

export default __exports__